// extracted by mini-css-extract-plugin
export default {"details":"mainTopicDetails_details__LaxI+"};